import { useEffect, useMemo } from "react";
import LorsHero from "@/components/landing/lors/LorsHero";
import LorsTestimonials from "@/components/landing/lors/LorsTestimonials";
import LorsAbout from "@/components/landing/lors/LorsAbout";
import LorsRegistration from "@/components/landing/lors/LorsRegistration";
import LorsFooter from "@/components/landing/lors/LorsFooter";
import LorsStickyCta from "@/components/landing/lors/LorsStickyCta";
import { lorsContentMay20 } from "@/components/landing/lors/translationsMay20";
import { captureUtmsFromUrl } from "@/components/landing/lors/utmStorage";

const REDIRECT_TO = "/may-20-2026/ty";

const DIRECTIONS_URL =
  "https://www.google.com/maps/dir//Penngrove+Clubhouse,+385+Woodward+Ave,+Penngrove,+CA+94951/@38.2974964,-122.6680287,17z/data=!4m17!1m7!3m6!1s0x40763042cb6736eb:0x812236e841bff8bd!2sPenngrove+Clubhouse!8m2!3d38.2974922!4d-122.6654591!16s%2Fg%2F11b77ll0b2!4m8!1m0!1m5!1m1!1s0x40763042cb6736eb:0x812236e841bff8bd!2m2!1d-122.6653537!2d38.2975076!3e0?entry=ttu&g_ep=EgoyMDI2MDQyMS4wIKXMDSoASAFQAw%3D%3D";

const SUBHEAD_LINES = [
  "You're invited. One night. One room full of women.",
  "Everything you need to know to protect your money, your home, and your family.",
];

const May202026 = () => {
  useEffect(() => {
    captureUtmsFromUrl();
    const prev = document.documentElement.lang;
    document.documentElement.lang = "en";
    return () => {
      document.documentElement.lang = prev;
    };
  }, []);

  const copy = useMemo(() => lorsContentMay20.en, []);

  return (
    <main className="lors-theme">
      <LorsHero
        copy={copy}
        redirectTo={REDIRECT_TO}
        directionsUrl={DIRECTIONS_URL}
        headlineSizeClass="text-4xl md:text-[72px] leading-tight md:leading-[88px] font-bold"
        subheadLines={SUBHEAD_LINES}
        bulletsMontserrat
        formKey="may20"
      />
      <LorsTestimonials copy={copy} lang="en" />
      <LorsAbout copy={copy} />
      <LorsRegistration copy={copy} />
      <LorsFooter copy={copy} />
      <LorsStickyCta copy={copy} />
    </main>
  );
};

export default May202026;
